import { Interval } from 'types/generated/subscriptionsApi';

type GetPlanPricesReturn = {
    subscriptionPrice: number;
    monthlyEquivalentPrice: number;
    salePrice: number | undefined;
    monthlyEquivalentSale: number | undefined;
};

const getPlanPrices = ({
    subscriptionPrice,
    frequency,
    discountPercentage,
}: {
    subscriptionPrice: number;
    frequency: Interval;
    discountPercentage?: number;
}): GetPlanPricesReturn => {
    const isYearly = frequency === 'Yearly';

    const monthlyEquivalentPrice = isYearly
        ? subscriptionPrice / 12
        : subscriptionPrice;

    const salePrice = discountPercentage
        ? subscriptionPrice * ((100 - discountPercentage) / 100)
        : undefined;
    const monthlyEquivalentSale =
        salePrice && isYearly ? salePrice / 12 : salePrice;

    return {
        subscriptionPrice,
        monthlyEquivalentPrice,
        salePrice,
        monthlyEquivalentSale,
    };
};

export default getPlanPrices;
